/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Actions_RegenerateInputs */

const es_user_profile_api_keys_actions_regenerate = /** @type {(inputs: User_Profile_Api_Keys_Actions_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerar clave API`)
};

const en_user_profile_api_keys_actions_regenerate = /** @type {(inputs: User_Profile_Api_Keys_Actions_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate API key`)
};

/**
* | output |
* | --- |
* | "Regenerate API key" |
*
* @param {User_Profile_Api_Keys_Actions_RegenerateInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_actions_regenerate = /** @type {((inputs?: User_Profile_Api_Keys_Actions_RegenerateInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Actions_RegenerateInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_actions_regenerate(inputs)
	return en_user_profile_api_keys_actions_regenerate(inputs)
});
export { user_profile_api_keys_actions_regenerate as "user.profile.api_keys.actions.regenerate" }